<template>
  <div class="coupon-status-card mb-3">
      <h3 class="title">訂單編號: {{ redemptionId }}</h3>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
// import http from '../../helpers/http';

export default {
  props: { redemptionId: String },
  computed: {
    ...mapGetters(['role']),
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/mixin/modal/modal-history-status';

.coupon-status-card {
  @include container;

  img {
    @include image;
  }

  .title{
    @include title;
    text-align: center;
    color: rgb(45, 84, 143);
  }
}

</style>
